import { type ReactElement, type ReactNode, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { LanguageContext } from './context'
import { i18nInstance } from './I18nProvider'

interface LanguageContextProps {
  children: ReactNode
}

export const LanguageContextStore = observer(
  ({ children }: LanguageContextProps): ReactElement => {
    const [selectedLanguage, setSelectedLanguage] = useState<string>(
      i18nInstance.getCurrentLanguage()
    )

    useEffect(() => {
      const unsubscribe = i18nInstance.onLanguageChange((language) => {
        setSelectedLanguage(language)
      })
      return unsubscribe
    }, [])

    return (
      <LanguageContext.Provider value={{ selectedLanguage }}>
        {children}
      </LanguageContext.Provider>
    )
  }
)
